export const tagsList = [
  "Scandinavian",
  "Modern",
  "Contemporary",
  "Minimalist",
  "Smart",
  "Smart spaces",
  "Homie",
  "Cozy",
  "Clean",
  "Colorful",
  "Mood",
  "Vibes",
  "Lights",
  "Warm",
  "Cold",
  "Tones",
  "Pastels",
  "Bold",
  "Trending",
  "Trendy",
  "Monochrome",
  "Accent",
  "Economic",
  "Luxury",
  "Fair priced",
  "New",
  "Old",
  "New normal",
  "Open space",
  "Tech",
  "Coworking",
  "Modular",
  "Mindfulness",
  "Corporate",
  "Relaxing",
  "Gaming",
  "Industrial",
  "Art Deco",
  "Wood",
  "Concrete",
  "Future",
  "Plant",
  "Wabisabi",
  "Wallpaper",
  "Details",
  "Neutral",
  "Décor",
  "Marble",
  "Lightning",
  "Black",
  "Natural",
  "Art",
  "Fireplace",
  "Brick",
  "Project",
  "Rendering",
];
